import { Button } from '@/components/ui/button';
import { monthLabel, shiftMonth } from '@/lib/format';

/*
 * 矢印はモバイルでだけ 44px 角に広げる (指で押せる下限)。`Button` の既定
 * (px-3 py-2) は約 38px しかない。768px 以上は既定に戻すので描画は変わらない。
 */
const ARROW = 'min-h-11 min-w-11 px-4 md:min-h-0 md:min-w-0 md:px-3';

/** 対象年月の前後移動。粒度は月までなので、これ以上細かい選択肢は出さない。 */
export function MonthPicker({
  month,
  onChange,
}: {
  month: string;
  onChange: (month: string) => void;
}) {
  return (
    <div className="flex items-center">
      <Button aria-label="前の月" className={ARROW} onClick={() => onChange(shiftMonth(month, -1))}>
        ←
      </Button>
      <span className="border-y border-line-bold px-4 py-2 font-mono text-sm whitespace-nowrap text-ink-secondary">
        {monthLabel(month)}
      </span>
      <Button aria-label="次の月" className={ARROW} onClick={() => onChange(shiftMonth(month, 1))}>
        →
      </Button>
    </div>
  );
}
